import { Table } from 'antd'
import styles from './index.module.css'

// const dataSource = [
//   {
//     key: '1',
//     name: 'John Doe',
//     age: 32,
//     address: 'New York No. 1 Lake Park',
//   },
//   {
//     key: '2',
//     name: 'Jim Green',
//     age: 42,
//     address: 'London No. 1 Lake Park',
//   },
//   {
//     key: '3',
//     name: 'Joe Black',
//     age: 32,
//     address: 'Sidney No. 1 Lake Park',
//   },
// ]

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
    },
]

const FoldingTable = ({specifications}) => {
    return (
        <div className={styles.container}>
            <Table
                dataSource={specifications}
                columns={columns}
                pagination={false} // 不显示分页
                showHeader={false} // 不显示表头
                className={styles.custom_table}
                rowClassName={(record, index) => (index % 2 === 0 ? "even_row" : "odd_row")} // 隔行变色
            />
        </div>
    )
}

export default FoldingTable